// @ngInject
function acpOcLazyLoadDecorator($delegate) {
  $delegate.loadModule = function(module) {
    return $delegate.load([{ name: (module.default || module).name }]);
  };
  return $delegate;
}

export default acpOcLazyLoadDecorator;
